import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

export default function StepSection({ stepNumber, title, description, imageSrc }) {

    return (
        <Box my={6}>
            <Grid
                container
                spacing={2}
                alignItems="center"
                flexWrap={'wrap'}
                direction={{
                    xs: 'column',     
                    md: 'column',  
                    lg: stepNumber % 2 === 0 ? 'row-reverse' : 'row',
                }}
            >
                <Grid item xs={12} md={6} >
                    <Box display="flex" justifyContent="flex-start" alignItems="center" gap={2} >
                        <Box
                            sx={{
                                width: 70,
                                height: 70,
                                borderRadius: '50%',
                                backgroundColor: '#4da6e7',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: '50px',
                            }}
                        >
                            {stepNumber}
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {title}
                        </Typography>
                    </Box>

                    <Typography variant="body1" marginTop={2} maxWidth={{xs: '400px', lg: '457px' }} sx={{ fontSize: '16px'}}>
                        {description}
                    </Typography>
                </Grid>

                {/* Imagem */}
                <Grid item xs={12} md={6}>
                    <Box
                        component="img"
                        src={imageSrc}
                        alt={`Passo ${stepNumber}`}
                        sx={{
                            width: '100%',
                            maxWidth: 500,
                            display: 'block',
                            borderRadius: 2,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
